/**
 * sf-video-wall — opens a video in a native <dialog> when a card is clicked.
 *
 * Progressive enhancement: each card already carries a link to the video file, so with
 * JavaScript disabled the video simply opens in a new tab.
 */
class SfVideoWall extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-video-dialog]');
    this.player = this.querySelector('[data-video-player]');
    if (!this.dialog || !this.player) return;

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-video-trigger]');
      if (trigger) {
        const url = trigger.dataset.videoUrl;
        if (!url) return;
        event.preventDefault();
        this.open(url, trigger.dataset.videoTitle || '');
        return;
      }

      if (event.target.closest('[data-video-close]')) {
        event.preventDefault();
        this.dialog.close();
      }
    });

    // clicking the backdrop (the dialog element itself) closes it
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    this.dialog.addEventListener('close', () => {
      this.player.pause();
      this.player.removeAttribute('src');
      this.player.load();
      this.lastTrigger?.focus?.();
    });

    this.player.addEventListener('ended', () => this.dialog.close());
  }

  open(url, title) {
    this.lastTrigger = this.querySelector(`[data-video-url="${CSS.escape(url)}"]`);
    this.player.src = url;
    if (title) this.player.setAttribute('title', title);
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
    this.player.play().catch(() => {});
  }
}

if (!customElements.get('sf-video-wall')) customElements.define('sf-video-wall', SfVideoWall);
